import { fromJS } from "immutable";
import { v4 as uuidv4 } from 'uuid';
import requestStatus from "../../constants/requestStatus"
import actionTypes from '../../actions/actionTypes'
import tempIdGenerator from "../../functions/tempIdGenerator";
import { immutableAddItemToArray, immutableRemoveItemfromArray, immutableReorderListItems } from "../../functions/listsImmutable";


const INIT_STATE = fromJS({
    status: requestStatus.INITIALIZED,
    error: null,
    selector: {
        edited: false,
        items: {},
        order: []
    }
});

const onRequest = (state, action)   => state.set('status', requestStatus.REQUEST_PENDING)
                                            .set('error', '')

const onError = (state, action)     => state.set('status', requestStatus.REQUEST_ERROR)
                                            .set('error', action.payload.errorMessage)

const onSuccess = (state, action)   => {
    return state.set('status', requestStatus.REQUEST_SUCCESS)
                .set('error', '')
                .set('selector', fromJS(action.payload))
}

const onFilterSuccess = (state, action) => {
    if(action.payload) {
        state = state.set('selector', fromJS({
            edited: action.payload.edited,
            items: action.payload.items,
            order: action.payload.order
        }))
    }

    return state.set('status', requestStatus.REQUEST_SUCCESS)
                .set('error', '')
}

const onReorder = (state, action) => {
    const { oldIndex, newIndex } = action.payload
    const oldOrder = state.getIn(['selector', 'order'])
    const newOrder = immutableReorderListItems(oldOrder, oldIndex, newIndex) 

    return state.setIn(['selector', 'order'], newOrder)
                .setIn(['selector', 'edited'], true)
}

const addItem = (state, data)  => {
    const newItemId = tempIdGenerator()
    const newOrder = immutableAddItemToArray(state.getIn(['selector', 'order']), newItemId)

    const newItem = {
        pk: newItemId,
        ...data
    }

    return state.setIn(['selector', 'items', newItemId], fromJS(newItem))
                .setIn(['selector', 'order'], newOrder)
                .setIn(['selector', 'edited'], true)
}

const onAddItemCustom = (state, action) => {
    const { title, url, cinemaPk } = action.payload
    const data = {
        type: 'customObject',
        cinemaPk: cinemaPk,
        title: title,
        url: url
    }

    return addItem(state, data)



    // const newItemId = tempIdGenerator()‚
    // const { title, url, cinemaPk } = action.payload

    // const newOrder = immutableAddItemToArray(state.getIn(['selector', 'order']), newItemId)
    // const newItem = fromJS({
    //     pk: newItemId,
    //     cinemaPk: cinemaPk,
    //     type: 'customObject',
    //     title: title,
    //     url: url,
    // })

    // return state.setIn(['selector', 'items', newItemId], newItem)
    //             .setIn(['selector', 'order'], newOrder)
    //             .setIn(['selector', 'edited'], true)
}

const onAddItemCinema = (state, action) => {
    const { cinemaPk } = action.payload
    const data = {
        type: 'cinemaObject',
        cinemaPk: cinemaPk
    }

    return addItem(state, data)

    // const newItemId = tempIdGenerator()
    // const { cinemaPk } = action.payload
    // const newOrder = immutableAddItemToArray(state.getIn(['selector', 'order']), newItemId)
    // const newItem = fromJS({
    //     pk: newItemId,
    //     cinemaPk: cinemaPk,
    //     type: 'cinemaObject'
    // })

    // return state.setIn(['selector', 'items', newItemId], newItem)
    //             .setIn(['selector', 'order'], newOrder)
    //             .setIn(['selector', 'edited'], true)
}

const onRemoveItem = (state, action) => {
    const pk = action.payload.pk.toString()
    const newOrder = immutableRemoveItemfromArray(state.getIn(['selector', 'order']), pk)

    return state.removeIn(['selector', 'items', pk])
                .setIn(['selector', 'order'], newOrder)
                .setIn(['selector', 'edited'], true)

}


const multisiteSelectorReducer = (state = INIT_STATE, action) => {
    switch(action.type) {
        case actionTypes.MULTISITE_SELECTOR_GET_REQUEST:
        case actionTypes.MULTISITE_SELECTOR_FILTER_REQUEST:
        case actionTypes.MULTISITE_SELECTOR_UPDATE_REQUEST:
            return onRequest(state, action);
        case actionTypes.MULTISITE_SELECTOR_GET_SUCCESS:
        case actionTypes.MULTISITE_SELECTOR_UPDATE_SUCCESS:
            return onSuccess(state, action);
        case actionTypes.MULTISITE_SELECTOR_FILTER_SUCCESS:
            return onFilterSuccess(state, action)
        case actionTypes.MULTISITE_SELECTOR_GET_ERROR:
        case actionTypes.MULTISITE_SELECTOR_FILTER_ERROR:
        case actionTypes.MULTISITE_SELECTOR_UPDATE_ERROR:
            return onError(state, action);
        case actionTypes.MULTISITE_SELECTOR_ORDER_UPDATE:
            return onReorder(state, action)
        case actionTypes.MULTISITE_SELECTOR_ITEM_ADD_CUSTOM_OBJ:
            return onAddItemCustom(state, action)
        case actionTypes.MULTISITE_SELECTOR_ITEM_ADD_CINEMA_OBJ:
            return onAddItemCinema(state, action)
        case actionTypes.MULTISITE_SELECTOR_ITEM_REMOVE:
            return onRemoveItem(state, action)
        default:
            return state
    }
}

export default multisiteSelectorReducer